import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SubDepartmentModel, UserFavoriteModal, subCategories } from '../../../Models/ApplicationModels';
import { FavouritesStateService } from '../../../Services/favourites-state.service';
import { MasterDataSeriveService } from '../../../Services/master-data-serive.service';
import { DynamicTranslationService } from '../../../dynamic-translation.service';
import { BreadcrumbService } from '../../../Services/breadcrumb.service';
import { TranslationService } from '../../../translation.service';
import { TranslationCommunicationServiceService } from '../../../translation-communication-service.service';
import { GoogleTranslateService } from '../../../Services/google-translate.service';

@Component({
  selector: 'app-sub-category-production',
  templateUrl: './sub-category-production.component.html',
  styleUrls: ['./sub-category-production.component.css']
})
export class SubCategoryProductionComponent implements OnDestroy {
  isButtonActive: boolean = false;
  urlName: string = "";
  renderWomensDepartmentDat: Array<SubDepartmentModel> = [];
  renderWomensDepartmentDataForOriginal: Array<SubDepartmentModel> = [];
  subCategories: Array<subCategories> = []
  translatedTexts: string[] = [];
  subDepartmentDescrListinEnglish: any[] = [];
  deptDetails: any;
  departmentName: any;
  combinedItemsList: Array<UserFavoriteModal> = [];
  userFavoriteModal: UserFavoriteModal = new UserFavoriteModal();
  userDetails: any;
  favQuantity: any;
  formMasters: string[] = [];
  selectedLanguage: string = 'en';
  private languageSubscription!: Subscription;

  constructor(private masterService: MasterDataSeriveService, private route: Router, public translationService: TranslationService,
    private dynamicTranslationService: DynamicTranslationService, private translationCommunicationService: TranslationCommunicationServiceService,
    private breadcrumbService: BreadcrumbService, private googleTranslateService: GoogleTranslateService,
    private favouritesState: FavouritesStateService) { }

  ngOnInit() {
    this.languageSubscription = this.translationCommunicationService
      .getSelectedLanguage()
      .subscribe((language) => {
        this.selectedLanguage = language;
      });

    let categoryDetails = JSON.parse(localStorage.getItem('CategoryDetails') || '{}');
    let CategoryDataFromFavList = JSON.parse(localStorage.getItem('CategoryData') || '{}');
    let originalCtgName = categoryDetails.categoryName || this.deptDetails.categoryName || CategoryDataFromFavList.categoryName;
    this.breadcrumbService.updateActiveCategoryTab(originalCtgName);
    this.breadcrumbService.updateActiveSubCategoryTab('Choose Sub-Categories');


    this.getProductionSubCategory();
    this.activeDepartment();
    this.getdeptId();

    const hasFav = this.favouritesState.getFlag();
    if (hasFav !== false) {
      this.getAllFavItems();
    } else {
      this.favQuantity = '00';
    }
  }

  ngOnDestroy() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  // getPermissions() {
  //   this.masterService.loadUserPermissions().subscribe(data => {
  //     this.formMasters = data[0];
  //   });
  // }

  getProductionSubCategory() {

    let categoryDetails = JSON.parse(localStorage.getItem('CategoryDetails')!);
    let userDetails = this.masterService.getUserDetailsFromStorage();
    let categoryId = categoryDetails.categoryId == null ? categoryDetails.categoryId : categoryDetails.categoryId
    let departmentId = categoryDetails.departmentId == null ? categoryDetails.departmentId : categoryDetails.departmentId
    this.masterService.getProductionSubCategory(userDetails.companyID, departmentId, categoryId).subscribe((res) => {
      this.subCategories = res as subCategories[];
      // this.subCategories = this.subCategories.filter(item =>
      //   !this.subCategories.some(sub => sub.parentSubCategoryID === item.subCategoryID)
      // );
      setTimeout(() => {
        this.googleTranslateService.changeLanguage(this.selectedLanguage);
      }, 100);
    })
  }
  getdeptId() {

    let dept: any = JSON.parse(localStorage.getItem('deptID') || '{}');
    let User: any = localStorage.getItem('user');
    this.userDetails = JSON.parse(User);
    let departmentIdToUse = dept.departmentId !== undefined ? dept.departmentId : dept.departmentId;
    this.subDepartmentData(departmentIdToUse, this.userDetails.userId);
  }

  async subDepartmentData(deptId: number, companyId: number) {
    const storeGroup = localStorage.getItem('storeGroup');
    const selectedstoreGroupId = storeGroup ? parseInt(storeGroup, 10) : 0;
    this.masterService.getCategoriesByDeptUserID(deptId, companyId, true, selectedstoreGroupId).subscribe((result: any) => {
      this.renderWomensDepartmentDat = result as SubDepartmentModel[];

      this.renderWomensDepartmentDataForOriginal = result as SubDepartmentModel[];
      setTimeout(() => {
        this.googleTranslateService.changeLanguage(this.selectedLanguage);
      }, 100);
    })
  }

  selectedCategory(data: any) {

    localStorage.removeItem('CategoryData');
    localStorage.setItem('CategoryDetails', JSON.stringify(data));
    localStorage.setItem('ctgnamefromsubdept', JSON.stringify(data.categoryName));
    if (data.categoryId == 0 || data.categoryId == 0) {
      const url = '/production/home/sub-dept';
      this.route.navigateByUrl(url);
      localStorage.setItem('deptID', JSON.stringify(data));
      this.breadcrumbService.updateActiveDeptTab(data.departmentDescr);

      this.toggleButtons();
    }
    else if (data.categoryId > 0 || data.categoryId > 0) {
      this.route.navigateByUrl('/production/home/prod-item');
      localStorage.setItem('deptID', JSON.stringify(data));
    }
  }

  toggleButtons() {

    this.isButtonActive = !this.isButtonActive;
    if (this.isButtonActive == false) {
      this.getdeptId();
    } else {
      this.getAllFavItems();
    }
  }

  getAllFavItems() {

    const userDetails = this.masterService.getUserDetailsFromStorage();
    this.masterService.getUserFavourites(userDetails.userId).subscribe((res) => {
      this.combinedItemsList = res as UserFavoriteModal[];
      this.favQuantity = this.combinedItemsList.length;
      if (this.favQuantity < 10) {
        this.favQuantity = '0' + this.favQuantity.toString();
      }
      else {
        this.favQuantity = this.favQuantity;
      }
      this.favouritesState.setFlag(this.combinedItemsList.length > 0);
      setTimeout(() => {
        this.googleTranslateService.changeLanguage(this.selectedLanguage);
      }, 100);
    })
  }

  fav(favItem: any) {
    const userDetails = this.masterService.getUserDetailsFromStorage();
    this.userFavoriteModal.userId = userDetails.userId;
    this.userFavoriteModal.departmentId = favItem.departmentID || favItem.departmentId;
    this.userFavoriteModal.companyId = userDetails.companyID;
    this.userFavoriteModal.favoriteId = favItem.favoriteId || favItem.favoriteID;
    this.userFavoriteModal.favoriteID = favItem.favoriteId || favItem.favoriteID;
    this.userFavoriteModal.subCategoryId = favItem.subCategoryID || favItem.subCategoryId;
    this.userFavoriteModal.categoryId = favItem.categoryID || favItem.categoryId;
    if (favItem.favoriteId > 0) {
      this.userFavoriteModal.active = false;
    }
    else {
      if (favItem.favoriteID == null || favItem.favoriteID == 0 && (favItem.favoriteId == 0 || favItem.favoriteId == null)) {
        this.userFavoriteModal.active = true;
      }
      else {
        this.userFavoriteModal.active = false;
      }
    }
    if (this.userFavoriteModal.active === true) {
      this.favouritesState.setFlag(true);
    }
    this.masterService.addUpdateUserFavorite(this.userFavoriteModal).subscribe((res) => {
      this.getdeptId();
      this.getAllFavItems();
      this.getProductionSubCategory();
    })
  }

  //Translation logic:
  updateSubDepartmentContent(): void {
    this.dynamicTranslationService.translateText(this.subDepartmentDescrListinEnglish).subscribe((translatedDescriptions: string[]) => {
      const translatedCategoryNames = translatedDescriptions;
      this.renderWomensDepartmentDat.forEach((dept, index) => {
        dept.categoryName = translatedCategoryNames[index];
      });
    });
  }

  translateText(inputText: any) {
    this.dynamicTranslationService.translateText(inputText).subscribe((translatedTexts: string[]) => {

      this.translatedTexts = translatedTexts;
      this.updateSubDepartmentContent();
    });
  }

  deptId: any;
  activeDepartment() {

    this.deptDetails = JSON.parse(localStorage.getItem('deptID') || '{}');
    this.deptId = this.deptDetails.departmentId || this.deptDetails.departmentId
    this.masterService.getDepartmentById(this.deptId).subscribe((res: any) => {

      this.breadcrumbService.updateActiveDeptTab(res.departmentDescr);
      localStorage.removeItem('isNavigatingBack');
      localStorage.setItem('isNavigatingBack', 'false');
    })
  }
}
